import { isFeatureEnabled, FEATURES } from '@utils/featureFlags';

export const promoLinks = [ ...(isFeatureEnabled(FEATURES.MULTI_TENANCY)
  ? [ {
    url: 'https://www.griddynamics.com/solutions/digital-enterprises-composable-commerce-starter-kit',
    name: 'Composable Commerce Starter Kit for Modern Digital Enterprises'
  } ]
  : []),
...(process.env.NEXT_PUBLIC_PAYMENT_PROVIDER === 'stripe'
  ? [ {
    url: 'https://www.griddynamics.com/solutions/commercetools-starter-kit',
    name: 'commercetools Composable Commerce Starter Kit'
  } ]
  : []), {
  url: 'https://marketplace.commercetools.com/accelerators/composable-commerce-starter-kit',
  name: 'Composable Commerce Starter Kit by Grid Dynamics'
} ];
